// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__r_vGD","content":"styles_content__3JAyq","row":"styles_row__3xY0a","footer":"styles_footer__1cwyd","phraseLength":"styles_phraseLength__Gi_Lk"};